import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import styles from "../../../styles/common-media-styles.module.css";

interface ItemTotalInMediaProps {
  amountOfMedias: number;
}

export const ItemTotalInMedia = ({ amountOfMedias }: ItemTotalInMediaProps) => {
  const { t } = useTranslation();
  return (
    <FixaText
      textStyle={"Heading.XS"}
      className={styles["total-in-media-text-color"]}
      data-test-id="item-total-in-media"
    >
      {t("inXMediaString", {
        count: amountOfMedias,
      })}
    </FixaText>
  );
};
